import { transformDateToLocalDateString } from "helpers";
import { FleetDocumentRow } from "services/api/fleet/vehicles/documents/types";
import { ButtonMenu } from "ui/components/Button/ButtonMenu";
import ButtonMenuItem from "ui/components/Button/ButtonMenu/ButtonMenuItem";
import { Column, ColumnTypes } from "ui/components/Table/TableSearch/types";

export const FLEET_TIRE_SET_DOCUMENT_UPLOADS_SEARCH_COLUMNS = (
  t: (key: string) => string
): Column[] => [
  {
    title: "",
    field: "",
    type: ColumnTypes.string,
  },
  {
    title: "admin.fleet.tires.set.document.uploads.search.name",
    field: "",
    type: ColumnTypes.string,
  },
  {
    title: "",
    field: "",
    type: ColumnTypes.string,
  },
];

export const FLEET_TIRE_SET_DOCUMENT_SEARCH_COLUMNS = (
  t: (key: string) => string,
  onDeleteClick: (
    event: React.MouseEvent<HTMLSpanElement>,
    id: string
  ) => void
): Column[] => {
  return [
    {
      title: "",
      field: "image",
      type: ColumnTypes.custom,
      render: (row: FleetDocumentRow) => (
        <div>
          <div className="w-10 h-10 rounded-full bg-gray-200 block relative">
            <span className="absolute top-1/2 left-1/2 transform -translate-x-1/2 -translate-y-1/2">
              {row.documentType?.name.toString().charAt(0).toUpperCase()}
            </span>
          </div>
        </div>
      ),
    },
    {
      title: "admin.fleet.tires.set.document.search.name",
      field: "",
      type: ColumnTypes.custom,
      render: (row: FleetDocumentRow) => (
        <div>
          <div className="text-md">{row.name}</div>

        </div>
      ),
    },
    {
      title: "admin.fleet.tires.set.document.search.documenttype.name",
      field: "",
      type: ColumnTypes.custom,
      render: (row: FleetDocumentRow) => (
        <div>
          <div className="text-md">{row.documentType?.name}</div>
        
        </div>
      ),
    },
    {
      title: "admin.fleet.tires.set.document.search.description",
      field: "",
      type: ColumnTypes.custom,
      render: (row: FleetDocumentRow) => (
        <div className="text-sm font-light text-slate-500">
          {row.description}
        </div>
      ),
    },
    {
      title: "admin.fleet.tires.set.document.search.createdon",
      field: "",
      type: ColumnTypes.custom,
      render: (row: FleetDocumentRow) => (
        <div className="text-md">
          {transformDateToLocalDateString(row.created)}
        </div>
      ),
    },
    {
      title: "",
      key: "tire_set_document_actions",
      alwaysVisible: true,
      field: "",
      type: ColumnTypes.custom,
      render: (row: FleetDocumentRow) => (
        <ButtonMenu
          endIcon="/media/icons/more-dots.svg"
          cssClassName="h-full"
          variant="text"
        >
          <ButtonMenuItem
            startIcon="/media/icons/trash.svg"
            variant="remove"
            onClick={(e) => onDeleteClick(e, row.id)}
          >
            Obriši
          </ButtonMenuItem>
        </ButtonMenu>
      ),
    },
  ];
};
